
import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap'
import PropTypes from 'prop-types'

function CurrencyTableItem(props) {
    const { data, count,deleteCallback } = props;
    const onDelete = () => {
        deleteCallback(data.currency_code)
    }
    return (
        <tr>
            <td>{data.currency_code}</td>
            <td>{data.currency_name}</td>
            <td>
                <Row className="d-flex align-items-center m-0">
                    <Col xs="auto" sm="auto">
                        <Link className='text-success' to={"/currencies/"+ data.currency_code} >
                            <i className="fas fa-pen"></i>
                        </Link>
                    </Col>
                    <Col xs="auto" sm="auto">
                        <a className='text-danger' onClick={onDelete} >
                            <i className="fas fa-trash"></i>
                        </a>
                    </Col>
                </Row>
            </td>
        </tr>
    )

}
CurrencyTableItem.propTypes = {
    data: PropTypes.object,
    count: PropTypes.number,
    deleteCallback: PropTypes.func
}

export default CurrencyTableItem;
